import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import useLenis from "@/hooks/useLenis";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Corridors } from "@/components/landing/Corridors";
import { TrustMatrix } from "@/components/landing/TrustMatrix";
import { Process } from "@/components/landing/Process";
import { Testimonials } from "@/components/landing/Testimonials";
import { FaqSection } from "@/components/landing/FaqSection";
import { CtaBand } from "@/components/landing/CtaBand";
import { Footer } from "@/components/landing/Footer";
import { StickyCta } from "@/components/landing/StickyCta";

export default function Landing() {
  const [stats, setStats] = useState(null);
  useLenis(true);

  useEffect(() => {
    document.title = "BRICKSPACE | Real Estate Consultancy · NH-24 Ghaziabad";
    axios
      .get(`${API}/public/stats`)
      .then(({ data }) => setStats(data))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero stats={stats} />
        <Corridors />
        <TrustMatrix />
        <Process />
        <Testimonials />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}
